<!-- SPDX-License-Identifier: AGPL-3.0-or-later -->

<h1 mat-dialog-title>Confirm {{ actionToPerform() }}</h1>
<div mat-dialog-content>
  @if (infoNote()) {
    <p>{{ infoNote() }}</p>
  }
  <p>Are you sure you want to do this?</p>
</div>
<div mat-dialog-actions>
  <button
    mat-flat-button
    [class.delete-button]="isDeleteDialog()"
    data-cy="confirm-dialog-btn"
    aria-label="{{ this.actionButtonText() }} button"
    [mat-dialog-close]="true"
    class="center-content"
  >
    {{ this.actionButtonText() ?? 'Confirm' }}
  </button>
  <button
    mat-button
    data-cy="cancel-dialog-btn"
    aria-label="cancel-action button"
    [mat-dialog-close]="false"
  >
    Cancel
  </button>
</div>
